<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold" v-b-toggle.accordion-1>
          <font-awesome-icon icon="chevron-down"
            :class="['float-left', filtrosVisiveis ? 'rotating-up' : 'rotating-down']" style="margin-top: 0.75rem" />
          Aditivos de Convênio e outros Instrumentos congêneres
          <b-button class="float-right m-1" size="sm" @click="importarXML()">
            <font-awesome-icon icon="file-upload" class="mr-2" />Importar XML
          </b-button>
          <b-button size="sm" class="float-right m-1" @click="cadastrarNovoAditivo">
            <font-awesome-icon icon="plus" class="mr-2" />
            Novo Aditivo
          </b-button>
        </h6>
      </template>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel" v-model="filtrosVisiveis">
        <b-card-body>
          <b-container>
            <b-form @submit.stop.prevent="filtrarAditivos">
              <b-row>
                <b-col cols="12" sm="7" lg="4" xl="3">
                  <b-form-group id="input-group-filtroNumero" label="Número" label-for="input-filtroNumero"
                    label-class="text-left">
                    <b-form-input id="input-filtroNumero" v-model="filtros.numero" type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="5" lg="4" xl="3">
                  <b-form-group id="input-group-filtroAno" label="Ano" label-for="input-filtroAno"
                    label-class="text-left">
                    <b-form-input id="input-filtroAno" v-model="filtros.ano" type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6" xl="6">
                  <b-form-group id="input-group-filtroJustificativa" label="Justificativa"
                    label-for="input-filtroJustificativa" label-class="text-left">
                    <b-form-input id="input-filtroJustificativa" v-model="filtros.justificativa" type="text">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col id="input-group-filtroConvenio" cols="12" xl="6">
                  <span class="d-block text-left pb-1">Instrumento</span>
                  <multiselect @input="updateFiltroConvenio" v-model="convenioSelecionado" open-direction="bottom"
                    :close-on-select="true" :searchable="true" deselect-label="" :allow-empty="true"
                    placeholder="Selecione o instrumento" track-by="Codigo" :options="convenios" label="Nome"
                    :show-labels="false">
                    <template slot="noOptions">
                      <small><i>Erro ao obter dados.</i></small>
                    </template>
                    <template slot="noResult">
                      <i>Sem resultados.</i>
                    </template>
                  </multiselect>
                </b-col>
                <b-col cols="12" xl="3">
                  <b-form-group id="input-group-filtroNaturezaAjuste" label="Natureza de Ajuste"
                    label-for="input-filtroNaturezaAjuste" label-class="text-left">
                    <b-form-select id="input-filtroNaturezaAjuste" v-model="filtros.idNatureza"
                      :options="naturezasAjuste"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="4" class="pt-4">
                  <div class="d-flex">
                    <b-button size="sm" variant="outline-secondary" class="mr-2" @click="limparFiltros">
                      <font-awesome-icon icon="redo" class="mr-2" />
                      Limpar Filtros
                    </b-button>
                    <b-button size="sm" variant="outline-secondary" type="submit">
                      <font-awesome-icon icon="filter" class="mr-2" />
                      Filtrar
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-container>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card class="m-3" id="aditivo-convenio-table-Card" no-body header-tag="header">
      <template #header>
        <h6 class="mb-0 text-center">Resultados</h6>
      </template>
      <b-card-text>
        <b-table :busy="tableBusy" :fields="fields" hover no-border-collapse :items="items" sort-by="" :sort-desc="true"
          striped stacked="md" per-page="0" :current-page="currentPage" show-empty small>
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="actions-icons">
              <b-link class="text-dark" @click="detalhesAditivo(row.item.IdAditivo)">
                <font-awesome-icon icon="eye" />
                <div style="font-size: 12px">Ver Detalhes</div>
              </b-link>
              <b-link class="text-dark" @click="editarAditivo(row.item.IdAditivo)">
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
              <btn-excluir :idItem="row.item.IdAditivo" :excluirItem="removerAditivo" />
            </div>
          </template>
        </b-table>
        <table-pagination v-if="totalRows" :total-rows="totalRows" :per-page="pageSize" @pageChange="pageChange">
        </table-pagination>
      </b-card-text>
    </b-card>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component';

import { UtilsTS } from '@/utilsts';
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import Multiselect from "vue-multiselect";
import { TableField } from '@/types/table-field'
import { store } from "@/store"

import aditivosConvenioService from '@/services/licitacoes/aditivosConvenioService'
import { fieldsAditivosConvenio } from '@/types/licitacoes/aditivo-convenio/fields-aditivos-convenio'
import { AditivoConvenioResumido } from '@/types/licitacoes/aditivo-convenio/aditivo-convenio-resumido'
import { FiltrosAditivosConvenio } from '@/types/licitacoes/aditivo-convenio/filtros-aditivos-convenio';

const CompProps = Vue.extend({
  name: 'ConsultarAditivosConvenio',
  components: { BtnExcluir, Multiselect, TablePagination },
})

@Component
export default class ConsultarAditivosConvenio extends mixins(UtilsTS, CompProps) {
  currentPage = 1
  fields: TableField[] = fieldsAditivosConvenio
  items: AditivoConvenioResumido[] = []
  tableBusy = false
  filtrosVisiveis = true
  convenioSelecionado: any = null
  filtros: FiltrosAditivosConvenio = new FiltrosAditivosConvenio()
  convenios: any[] = []
  naturezasAjuste: any[] = []
  tiposAditivo: any[] = []

  pageSize = 10
  totalRows: null | number = null

  async pageChange(value) {
    this.tableBusy = true;
    this.currentPage = value;
    await this.loadData();
  }

  async loadData(): Promise<void> {
    this.tableBusy = true
    try {
      const response = await aditivosConvenioService.filtrarAditivos(
        this.currentPage,
        this.pageSize,
        this.filtros
      );
      this.totalRows = response.totalRows;
      this.items = response.aditivosResumidos.map(p => {
        const retorno = Object.assign(new AditivoConvenioResumido(), p)
        retorno.tratarDadosDaAPI()
        return retorno
      })
    } catch (e: any) {
      this.items = []
      this.tratarError(e)
    } finally {
      this.tableBusy = false;
    }
  }

  async mounted() {
    try {
      store.blockScreen = true
      const responseConvenios = await aditivosConvenioService.listarConvenios()
      const responseNaturezasAjuste = await aditivosConvenioService.listarNaturezasAjuste()
      this.convenios = [{ Nome: 'TODOS', Codigo: null }, ...responseConvenios.data.map(c => {
        const limiteDescricao = 70
        const descricaoConvenio = c.DeObjetoConvenio.length > limiteDescricao ? c.DeObjetoConvenio.substring(0, limiteDescricao) + "..." : c.DeObjetoConvenio
        return { Codigo: c.IdConvenio, Nome: `${c.NrConvenio}/${c.NrAnoConvenio} - ${descricaoConvenio}` }
      }
      )]
      this.naturezasAjuste = [{ value: null, text: 'TODOS' }, ...responseNaturezasAjuste.data.map(t => ({ value: t.IdNaturezaAjuste, text: t.DeNaturezaAjuste }))]
      await this.loadData()
    } finally {
      store.blockScreen = false
    }
  }

  filtrarAditivos() {
    this.pageChange(1);
  }

  limparFiltros() {
    this.convenioSelecionado = null;
    this.filtros.limpar();
    this.pageChange(1);
  }

  updateFiltroConvenio() {
    this.filtros.idConvenio = this.convenioSelecionado.Codigo;
  }

  importarXML(): void {
    this.$router.push('/modulo-licitacoes/aditivos-convenios/importar-xml')
  }

  cadastrarNovoAditivo(): void {
    this.$router.push('/modulo-licitacoes/aditivos-convenios/novo')
  }

  editarAditivo(idAditivo: string): void {
    this.$router.push('/modulo-licitacoes/aditivos-convenios/editar/' + idAditivo)
  }

  detalhesAditivo(idAditivo: string): void {
    this.$router.push('/modulo-licitacoes/aditivos-convenios/' + idAditivo)
  }

  async removerAditivo(id: number): Promise<void> {
    //console.log('remover aditivo foi chamado para o id ', id)
    try {
      store.blockScreen = true
      const resp = await aditivosConvenioService.removerAditivo(id)
      if (resp && resp.status === 204) {
        await this.loadData()
        this.$toast.success("Aditivo excluído com sucesso")
      } else {
        console.error('Erro ao remover aditivo', resp)
        this.$toast.error(resp.data.msg || 'Erro ao remover aditivo')
      }
    } catch (e: any) {
      console.error('Erro ao remover aditivo', e)
      this.$toast.error(e.message || 'Erro ao remover aditivo')
    } finally {
      store.blockScreen = false
    }
  }
};
</script>

<style scoped>
:deep(#input-group-filtroConvenio .multiselect) {
  width: 100%;
  max-width: 100%;
}

:deep(#input-group-filtroConvenio .multiselect__tags) {
  border: #ced4da solid 1px !important;
  border-radius: 3px !important;
}

:deep(#input-group-filtroConvenio .multiselect__option) {
  padding: 6px !important;
  min-height: 0;
  font-size: 16px;
}

:deep(#input-group-filtroConvenio .multiselect__option--selected) {
  color: #495057 !important;
  background: #fff;
  font-weight: 400;
}

:deep(#input-group-filtroConvenio .multiselect__content-wrapper) {
  border: 1px solid #ced4da;
  max-height: 200px !important;
}

:deep(#input-group-filtroConvenio .multiselect__option--highlight) {
  background: #007bff !important;
  color: #fff !important;
}

:deep(#input-group-filtroConvenio .multiselect__input,
.multiselect__single) {
  background-color: #fff !important;
  color: #495057 !important;
}

:deep(#input-group-filtroConvenio .multiselect__input::placeholder) {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #495057 !important;
}

:deep(#input-group-filtroConvenio .multiselect__input::active) {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  border: none;
}

:deep(#input-group-filtroConvenio .multiselect__tags) {
  background-color: #fff;
  color: #495057 !important;
  border-radius: 2px;
}

:deep(#input-group-filtroConvenio .multiselect__select:before) {
  color: #495057 !important;
  border-color: #495057 transparent transparent !important;
}

:deep(#input-group-filtroConvenio .multiselect) {
  z-index: 2;
}

:deep(#input-group-filtroConvenio .multiselect__placeholder) {
  color: #495057;
  font-weight: 400;
  font-size: 1rem;
}

:deep(#input-group-filtroConvenio .multiselect__single) {
  cursor: pointer;
}

:deep(#input-group-filtroConvenio .multiselect__input,
#input-group-filtroConvenio .multiselect__single) {
  vertical-align: initial;
}

:deep(#input-group-filtroConvenio .multiselect--disabled .multiselect__tags,
#input-group-filtroConvenio .multiselect--disabled .multiselect__tags span) {
  color: #6c757d !important;
}

:deep(#input-group-filtroConvenio .multiselect--disabled .multiselect__select) {
  background: #fff !important;
}

:deep(table.b-table div) {
    word-break: inherit
}
</style>